export enum ActivityLogPropertyTypes {
    String = 1,
    Currency,
    Number,
    Date,
    DateTime,
    Boolean,
    List,
    Percentage
}
